import { BaseShippingMethodsClient, PickupPoint, ShippingMethod } from "@core/types";
import { convertShippingMethod } from "./converters";
import { SupaShippingMethod } from "../types/supabaseFragments";

class ShippingMethodsClient extends BaseShippingMethodsClient {
  async getShippingMethods(zoneId?: string, productsWeight?: number): Promise<ShippingMethod[]> {
    if (!zoneId) return [];
    const { data } = await this.instance.get<Record<"shipping_methods", SupaShippingMethod>[]>(
      `/wp-json/wc/v3/shipping/zones/${zoneId}/methods`,
    );

    return data?.length ? data.map(({ shipping_methods }) => convertShippingMethod(shipping_methods)) : [];
  }

  async getPickupPoints(): Promise<PickupPoint[]> {
    throw new Error("getPickupPoints not implemented");
  }
}

export default ShippingMethodsClient;
